import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { DefaultModuleService } from 'app/shared/services/data-services/navigation/default-module.service';

@Injectable({ providedIn: 'root' })
export class DefaultRedirectGuard  {
  constructor(private router: Router, private defaultModuleService: DefaultModuleService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const module = this.defaultModuleService.getDefaultModule();
    this.router.navigate([module]);
    return false;
  }
}
